import apiClient from "./axiosClient";

// ============================================
// APPLY CLAIM APIs
// ============================================

//New Register Send Otp Api

export const sendRegistrationOtp = async (userName, mobileNumber) => {
    try{
        const res = await apiClient.post("/api/generate-registration-otp",{
            name : userName, mobile_number : mobileNumber
        })
        return res.data
    }
    catch(error){
        throw error?.response?.data ||
        {
            status: "error",
            message: "Something went wrong"
        }
    }
}

// Register New User Api 
export const verifyRegisterOtp = async(userName,mobileNumber,otp) =>{
    try{
        const res = await apiClient.post("/api/complete-registration",{
            name : userName, mobile_number : mobileNumber, otp: otp
        })
        return res.data
    }
    catch(error){
    throw error?.response?.data ||  {
    "status": "error",
    "message": "Invalid or expired OTP"
}
    }
}

//Login using otp
export const loginSendOtp = async(mobileNumber) =>{
    try{
        const res = await apiClient.post("/api/generate-login-otp",{
            mobile_number : mobileNumber
        })
        return res.data
    }
    catch(error){
    throw error?.response?.data ||{
    "status": "error",
    "message": "Something went wrong"
}
    }
}

//Verify Login Otp and Login
export const loginVerifyOtp = async(mobileNumber,otp) =>{
    try{
        const res = await apiClient.post("/api/verify-login-otp",{
            mobile_number: mobileNumber , otp: otp
        })
        return res.data
    }
    catch(error){
    throw error?.response?.data ||{
    "status": "error",
    "message": "Something went wrong"
}
    }
}

//Fetch Loan Details using Loan ID
export const fetchLoanById = async(loanId) =>{
    try{
        const encodedId = btoa(String(loanId))
        const res = await apiClient.get(`/api/loan/${encodedId}`)
        return res.data
    }
    catch(error){
    throw error?.response?.data || {
        "status": "error",
        "message": "Invalid loan ID format"
    }
    }
}

// Load Relationships
export const loadRelationships = async () => {
    try {
        const res = await apiClient.get("/api/relationships");
        return res.data;
    } catch (error) {
        throw error?.response?.data || {
            "status": "error",
            "message": "Failed to load relationships. Please try again later."
        }
    }
};

// Load Disease Categories
export const loadDiseases = async () => {
    try {
        const res = await apiClient.post("/api/load-diseases");
        return res.data;
    } catch (error) {
        throw error?.response?.data || {
            "status": "error",
            "message": "Failed to load diseases. Please try again later."
        }
    }
};

// Load Hospital Categories
export const loadHospitalCategories = async () => {
    try {
        const res = await apiClient.post("/api/load-hospital-categories");
        return res.data;
    } catch (error) {
        throw error?.response?.data || {
            "status": "error",
            "message": "Failed to load hospital categories. Please try again later."
        }
    }
};

// Search Hospitals
export const searchHospitals = async (search, hospitalCategoryId) => {
    try {
        const res = await apiClient.post("/api/search-hospitals", {
            search,
            hospital_category_id: btoa(String(hospitalCategoryId)),
        });
        return res.data;
    } catch (error) {
        throw error?.response?.data ||  	
        {
            "status": "error",
            "message": "Failed to load hospitals. Please try again later."
        }
    }
};

//Fetch Loan Deatils using AadharId
export const fetchLoansByAadhar = async(aadharNumber) => {
    try{
        const res = await apiClient.post("/api/fetch-loans-by-aadhar",{
            aadhar_number: btoa(aadharNumber)
        })
        return res.data
    }
    catch(error){
    throw error?.response?.data ||{
    "status": "error",
    "message": "Invalid Aadhaar number format"
}
    }
}

// Save Draft
export const saveDraft = async (formData) => {
    try {
        const res = await apiClient.post("/api/risk-fund-claims/save-draft", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return res.data;
    } catch (error) {
        throw error?.response?.data || {
            "status": "error",
            "message": "Failed to save draft. Please try again later."
        }
    }
};

//Delete Draft
 export const deleteDraft = async (riskFundClaimId) => {
    try{
        const res = await apiClient.post("/api/risk-fund-claims/delete",{
            risk_fund_claim_id : riskFundClaimId
        })
        return res.data
    }
    catch(error){
       throw error?.response?.data || {       
        "status": "error",
        "message": "The selected id is invalid."
       }
    }

 }

// Submit Risk Fund Claim (death or disease)
export const submitClaim = async (formData) => {
    try {
        const res = await apiClient.post("/api/risk-fund-claims/store", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return res.data;
    } catch (error) {
        throw error?.response?.data || {
            "status": "error",
            "message": "Failed to Risk Claim. Please try again later."
        }
    }
};

// Fetch Claim Details by encrypted claim ID
export const fetchClaimDetails = async (riskFundClaimId) => {
    try {
        const res = await apiClient.post("/api/risk-fund-claims/details", { id:riskFundClaimId });
        return res.data;
    } catch (error) {
        throw error?.response?.data || {
            "status": "error",
            "message": "Failed to fetch risk fund claim details. Please try again later."
        }
    }
};

